import { Component } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { ProjectPerspective } from "@app/projects/enumerators";
import { CountyProjectContextProps, withCountyProjectContext } from "@app/projects/CountyProjectContext";

import { ProjectRouteParams } from "@app/projects/projectRouteParams";
import * as H from "history";
import AccuracyAggregateDetails from "./AccuracyAggregateDetails";
import AccuracyAggregateInspectionDetails from "./AccuracyAggregateInspectionDetails";
import AccuracyAggregateInspectionDetailsByGroup from "./AccuracyAggregateInspectionDetailsByGroup";
import AccuracyDetails from "./AccuracyDetails";
import { AccuracyDetailsMultiRegion } from "./AccuracyDetailsMultiRegion";
import { AccuracyInspectionDetails } from "./AccuracyInspectionDetails";
import { DetailsFilters } from "./DetailsFilters";
import { Features } from "@app/feature-flags";
import { FeatureFlagContextProps, withFeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import { AccuracyTemplateContext } from "@app/templates";

interface DetailsOnlyProps {
  showStateOnlyItems: boolean;
}

type DetailsProps = RouteComponentProps<unknown, unknown, ProjectRouteParams> & CountyProjectContextProps & DetailsOnlyProps & FeatureFlagContextProps;

class Details extends Component<DetailsProps> {
  constructor(props: DetailsProps) {
    super(props);
  }

  public render() {
    const exportEndpoint = this.props.runConfiguration ? `${this.props.match.url}/export/${this.props.runConfiguration.projectRunConfigurationId}/${this.props.runConfiguration.isLatestPublished}` : "";
    const countyPerspectiveOnlyItems = this.props.perspective === ProjectPerspective.ByCounty;

    return (
      <>
        <AccuracyTemplateContext.Consumer>
          {(accuracyTemplate) => (
            <DetailsFilters
              {...this.props}
              accuracyTemplate={accuracyTemplate}
              showStateOnlyItems={this.props.showStateOnlyItems}
              exportEndpoint={exportEndpoint}
              showCreateReportsMenu={this.props.enabledFeatureFlags.has(Features.ENABLE_VIEW_BY_INSPECTION_UPDATES)}
            />
          )}
        </AccuracyTemplateContext.Consumer>
        <Switch>
          {this.props.perspective === ProjectPerspective.All
            && !this.props.regionFilters.county && (
              <Route
                exact={false}
                path={this.props.match.url}
                render={(props: RouteComponentProps<{ [x: string]: string }, unknown, ProjectRouteParams>) => <AccuracyDetailsMultiRegion exportEndpoint={exportEndpoint} {...props} />}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && !this.props.regionFilters.state && !this.props.regionFilters.county && !this.props.regionFilters.specialty && !this.props.regionFilters.inspection && (
              <Route
                exact={true}
                path={this.props.match.url}
                render={() => (this.renderAccuracyAggregateInspectionDetails(exportEndpoint))}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && this.props.regionFilters.state && this.props.regionFilters.county && !this.props.regionFilters.specialty && this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/state/:stateRegionCode/county/:countyRegionCode/inspection/:inspectionUid`}
                render={(props) => (
                  <AccuracyInspectionDetails
                    {...this.props}
                    location={this.props.location as H.Location<ProjectRouteParams>}
                    projectURL={this.props.location.pathname + this.props.location.search}
                    exportEndpoint={exportEndpoint}
                    inspectionBand={props.match.params.inspectionBand}
                    inspectionUid={props.match.params.inspectionUid}
                    networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
                  />
                )}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && this.props.regionFilters.state && !this.props.regionFilters.county && !this.props.regionFilters.specialty && !this.props.regionFilters.inspection && (
              <Route
                exact={true}
                path={`${this.props.match.url}/state/:stateRegionCode`}
                render={() => (this.renderAccuracyAggregateInspectionDetails(exportEndpoint))}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && !this.props.regionFilters.state && this.props.regionFilters.county && !this.props.regionFilters.specialty && !this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/county/:countyRegionCode`}
                render={() => (this.renderAccuracyAggregateInspectionDetails(exportEndpoint))}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && !this.props.regionFilters.state && !this.props.regionFilters.county && this.props.regionFilters.specialty && !this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/specialty/:specialtyGroupCode`}
                render={() => (this.renderAccuracyAggregateInspectionDetails(exportEndpoint))}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && this.props.regionFilters.state && !this.props.regionFilters.county && this.props.regionFilters.specialty && !this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/state/:stateRegionCode/specialty/:specialtyGroupCode`}
                render={() => (this.renderAccuracyAggregateInspectionDetails(exportEndpoint))}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && this.props.regionFilters.state && this.props.regionFilters.county && this.props.regionFilters.specialty && !this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/state/:stateRegionCode/county/:countyRegionCode/specialty/:specialtyGroupCode`}
                render={() => (this.renderAccuracyAggregateInspectionDetails(exportEndpoint))}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && !this.props.regionFilters.state && !this.props.regionFilters.county && !this.props.regionFilters.specialty && this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/inspection/:inspectionUid`}
                render={(props) => (
                  <AccuracyInspectionDetails
                    {...this.props}
                    location={this.props.location as H.Location<ProjectRouteParams>}
                    projectURL={this.props.location.pathname + this.props.location.search}
                    exportEndpoint={exportEndpoint}
                    inspectionBand={props.match.params.inspectionBand}
                    inspectionUid={props.match.params.inspectionUid}
                    networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
                  />
                )}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByCounty
            && this.props.regionFilters.state && !this.props.regionFilters.county && this.props.regionFilters.specialty && this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/state/:stateRegionCode/specialty/:specialtyGroupCode/inspection/:inspectionUid`}
                render={(props) => (
                  <AccuracyInspectionDetails
                    {...this.props}
                    location={this.props.location as H.Location<ProjectRouteParams>}
                    projectURL={this.props.location.pathname + this.props.location.search}
                    exportEndpoint={exportEndpoint}
                    inspectionBand={props.match.params.inspectionBand}
                    inspectionUid={props.match.params.inspectionUid}
                    networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
                  />
                )}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByCounty
            && this.props.regionFilters.state && !this.props.regionFilters.county && !this.props.regionFilters.specialty && this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/state/:stateRegionCode/inspection/:inspectionUid`}
                render={(props) => (
                  <AccuracyInspectionDetails
                    {...this.props}
                    location={this.props.location as H.Location<ProjectRouteParams>}
                    projectURL={this.props.location.pathname + this.props.location.search}
                    exportEndpoint={exportEndpoint}
                    inspectionBand={props.match.params.inspectionBand}
                    inspectionUid={props.match.params.inspectionUid}
                    networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
                  />
                )}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && !this.props.regionFilters.state && this.props.regionFilters.county && !this.props.regionFilters.specialty && this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/county/:countyRegionCode/inspection/:inspectionUid`}
                render={(props) => (
                  <AccuracyInspectionDetails
                    {...this.props}
                    location={this.props.location as H.Location<ProjectRouteParams>}
                    projectURL={this.props.location.pathname + this.props.location.search}
                    exportEndpoint={exportEndpoint}
                    inspectionBand={props.match.params.inspectionBand}
                    inspectionUid={props.match.params.inspectionUid}
                    networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
                  />
                )}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && !this.props.regionFilters.state && !this.props.regionFilters.county && this.props.regionFilters.specialty && this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/specialty/:specialtyGroupCode/inspection/:inspectionUid`}
                render={(props) => (
                  <AccuracyInspectionDetails
                    {...this.props}
                    location={this.props.location as H.Location<ProjectRouteParams>}
                    projectURL={this.props.location.pathname + this.props.location.search}
                    exportEndpoint={exportEndpoint}
                    inspectionBand={props.match.params.inspectionBand}
                    inspectionUid={props.match.params.inspectionUid}
                    networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
                  />
                )}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && this.props.regionFilters.state && !this.props.regionFilters.county && this.props.regionFilters.specialty && this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/state/:stateRegionCode/specialty/:specialtyGroupCode/inspection/:inspectionUid`}
                render={(props) => (
                  <AccuracyInspectionDetails
                    {...this.props}
                    location={this.props.location as H.Location<ProjectRouteParams>}
                    projectURL={this.props.location.pathname + this.props.location.search}
                    exportEndpoint={exportEndpoint}
                    inspectionBand={props.match.params.inspectionBand}
                    inspectionUid={props.match.params.inspectionUid}
                    networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
                  />
                )}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && this.props.regionFilters.state && this.props.regionFilters.county && !this.props.regionFilters.specialty && !this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/state/:stateRegionCode/county/:countyRegionCode`}
                render={() => (this.renderAccuracyAggregateInspectionDetails(exportEndpoint))}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && this.props.regionFilters.state && !this.props.regionFilters.county && this.props.regionFilters.specialty && !this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/specialty/:specialtyGroupCode/state/:stateRegionCode`}
                render={() => (this.renderAccuracyAggregateInspectionDetails(exportEndpoint))}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && this.props.regionFilters.state && !this.props.regionFilters.county && this.props.regionFilters.specialty && this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/specialty/:specialtyGroupCode/state/:stateRegionCode/inspection/:inspectionUid`}
                render={(props) => (
                  <AccuracyInspectionDetails
                    {...this.props}
                    location={this.props.location as H.Location<ProjectRouteParams>}
                    projectURL={this.props.location.pathname + this.props.location.search}
                    exportEndpoint={exportEndpoint}
                    inspectionBand={props.match.params.inspectionBand}
                    inspectionUid={props.match.params.inspectionUid}
                    networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
                  />
                )}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && this.props.regionFilters.state && this.props.regionFilters.county && this.props.regionFilters.specialty && this.props.regionFilters.inspection && (
              <Route
                exact={true}
                path={this.props.enabledFeatureFlags.has(Features.ENABLE_VIEW_BY_INSPECTION_UPDATES) ?
                  `${this.props.match.url}/state/:stateRegionCode/county/:countyRegionCode/specialty/:specialtyGroupCode/inspection/:inspectionUid/band/:inspectionBand`
                  : `${this.props.match.url}/state/:stateRegionCode/county/:countyRegionCode/specialty/:specialtyGroupCode/inspection/:inspectionUid`}
                render={(props) => (
                  <AccuracyInspectionDetails
                    {...this.props}
                    location={this.props.location as H.Location<ProjectRouteParams>}
                    projectURL={this.props.location.pathname + this.props.location.search}
                    exportEndpoint={exportEndpoint}
                    inspectionBand={props.match.params.inspectionBand}
                    inspectionUid={props.match.params.inspectionUid}
                    networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
                  />
                )}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && this.props.regionFilters.state && this.props.regionFilters.county && this.props.regionFilters.specialty && !this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/state/:stateRegionCode/specialty/:specialtyGroupCode/county/:countyRegionCode`}
                render={() => (this.renderAccuracyAggregateInspectionDetails(exportEndpoint))}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && this.props.regionFilters.state && this.props.regionFilters.county && this.props.regionFilters.specialty && this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={this.props.enabledFeatureFlags.has(Features.ENABLE_VIEW_BY_INSPECTION_UPDATES) ?
                  `${this.props.match.url}/state/:stateRegionCode/specialty/:specialtyGroupCode/county/:countyRegionCode/inspection/:inspectionUid/band/:inspectionBand`
                  : `${this.props.match.url}/state/:stateRegionCode/specialty/:specialtyGroupCode/county/:countyRegionCode/inspection/:inspectionUid/`}
                render={(props) => (
                  <AccuracyInspectionDetails
                    {...this.props}
                    location={this.props.location as H.Location<ProjectRouteParams>}
                    projectURL={this.props.location.pathname + this.props.location.search}
                    exportEndpoint={exportEndpoint}
                    inspectionBand={props.match.params.inspectionBand}
                    inspectionUid={props.match.params.inspectionUid}
                    networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
                  />
                )}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && !this.props.regionFilters.state && this.props.regionFilters.county && this.props.regionFilters.specialty && !this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/county/:countyRegionCode/specialty/:specialtyGroupCode`}
                render={() => (this.renderAccuracyAggregateInspectionDetails(exportEndpoint))}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && !this.props.regionFilters.state && this.props.regionFilters.county && this.props.regionFilters.specialty && this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/county/:countyRegionCode/specialty/:specialtyGroupCode/inspection/:inspectionUid`}
                render={(props) => (
                  <AccuracyInspectionDetails
                    {...this.props}
                    location={this.props.location as H.Location<ProjectRouteParams>}
                    projectURL={this.props.location.pathname + this.props.location.search}
                    exportEndpoint={exportEndpoint}
                    inspectionBand={props.match.params.inspectionBand}
                    inspectionUid={props.match.params.inspectionUid}
                    networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
                  />
                )}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && !this.props.regionFilters.state && this.props.regionFilters.county && !this.props.regionFilters.specialty && this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/county/:countyRegionCode/inspection/:inspectionUid`}
                render={(props) => (
                  <AccuracyInspectionDetails
                    {...this.props}
                    location={this.props.location as H.Location<ProjectRouteParams>}
                    projectURL={this.props.location.pathname + this.props.location.search}
                    exportEndpoint={exportEndpoint}
                    inspectionBand={props.match.params.inspectionBand}
                    inspectionUid={props.match.params.inspectionUid}
                    networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
                  />
                )}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && this.props.regionFilters.state && this.props.regionFilters.county && this.props.regionFilters.specialty && !this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/specialty/:specialtyGroupCode/state/:stateRegionCode/county/:countyRegionCode`}
                render={() => (this.renderAccuracyAggregateInspectionDetails(exportEndpoint))}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && this.props.regionFilters.state && this.props.regionFilters.county && this.props.regionFilters.specialty && this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/specialty/:specialtyGroupCode/state/:stateRegionCode/county/:countyRegionCode/inspection/:inspectionUid`}
                render={(props) => (
                  <AccuracyInspectionDetails
                    {...this.props}
                    location={this.props.location as H.Location<ProjectRouteParams>}
                    projectURL={this.props.location.pathname + this.props.location.search}
                    exportEndpoint={exportEndpoint}
                    inspectionBand={props.match.params.inspectionBand}
                    inspectionUid={props.match.params.inspectionUid}
                    networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
                  />
                )}
              />
            )}

          {this.props.perspective === ProjectPerspective.ByInspection
            && !this.props.regionFilters.state && this.props.regionFilters.county && this.props.regionFilters.specialty && !this.props.regionFilters.inspection && (
              <Route
                exact={false}
                path={`${this.props.match.url}/specialty/:specialtyGroupCode/county/:countyRegionCode`}
                render={() => (this.renderAccuracyAggregateInspectionDetails(exportEndpoint))}
              />
            )}

          <Route
            exact={true}
            path={this.props.match.url}
            render={(props: RouteComponentProps<{ [x: string]: string }, unknown, ProjectRouteParams>) => <AccuracyAggregateDetails exportEndpoint={exportEndpoint} showStateOnlyItems={this.props.showStateOnlyItems} countyPerspectiveOnlyItems={countyPerspectiveOnlyItems} {...props} />}
          />

          <Route
            exact={true}
            path={`${this.props.match.path}/specialty/:specialtyGroupCode`}
            render={(props: RouteComponentProps<{ [x: string]: string }, unknown, ProjectRouteParams>) => <AccuracyAggregateDetails exportEndpoint={exportEndpoint} showStateOnlyItems={this.props.showStateOnlyItems} countyPerspectiveOnlyItems={countyPerspectiveOnlyItems} {...props} />}
          />
          <Route
            exact={true}
            path={`${this.props.match.path}/specialty/:specialtyGroupCode/state/:stateRegionCode`}
            render={(props: RouteComponentProps<{ [x: string]: string }, unknown, ProjectRouteParams>) => <AccuracyDetails exportEndpoint={exportEndpoint} {...props} />}
          />
          <Route
            exact={true}
            path={`${this.props.match.path}/specialty/:specialtyGroupCode/county/:countyRegionCode`}
            render={(props: RouteComponentProps<{ [x: string]: string }, unknown, ProjectRouteParams>) => <AccuracyDetails exportEndpoint={exportEndpoint} {...props} />}
          />
          <Route
            exact={true}
            path={`${this.props.match.path}/specialty/:specialtyGroupCode/state/:stateRegionCode/county/:countyRegionCode`}
            render={(props: RouteComponentProps<{ [x: string]: string }, unknown, ProjectRouteParams>) => <AccuracyDetails exportEndpoint={exportEndpoint} {...props} />}
          />

          <Route
            exact={true}
            path={`${this.props.match.path}/state/:stateRegionCode`}
            render={(props: RouteComponentProps<{ [x: string]: string }, unknown, ProjectRouteParams>) => <AccuracyAggregateDetails exportEndpoint={exportEndpoint} showStateOnlyItems={this.props.showStateOnlyItems} countyPerspectiveOnlyItems={countyPerspectiveOnlyItems} {...props} />}
          />
          <Route
            exact={true}
            path={`${this.props.match.path}/state/:stateRegionCode/county/:countyRegionCode`}
            render={(props: RouteComponentProps<{ [x: string]: string }, unknown, ProjectRouteParams>) => <AccuracyDetails exportEndpoint={exportEndpoint} {...props} />}
          />
          <Route
            exact={true}
            path={`${this.props.match.path}/state/:stateRegionCode/specialty/:specialtyGroupCode`}
            render={(props: RouteComponentProps<{ [x: string]: string }, unknown, ProjectRouteParams>) => <AccuracyDetails exportEndpoint={exportEndpoint} {...props} />}
          />
          <Route
            exact={true}
            path={`${this.props.match.path}/state/:stateRegionCode/county/:countyRegionCode/specialty/:specialtyGroupCode`}
            render={(props: RouteComponentProps<{ [x: string]: string }, unknown, ProjectRouteParams>) => <AccuracyDetails exportEndpoint={exportEndpoint} {...props} />}
          />
          <Route
            exact={true}
            path={`${this.props.match.path}/state/:stateRegionCode/specialty/:specialtyGroupCode/county/:countyRegionCode`}
            render={(props: RouteComponentProps<{ [x: string]: string }, unknown, ProjectRouteParams>) => <AccuracyDetails exportEndpoint={exportEndpoint} {...props} />}
          />

          <Route
            exact={true}
            path={`${this.props.match.path}/county/:countyRegionCode/specialty/:specialtyGroupCode`}
            render={(props: RouteComponentProps<{ [x: string]: string }, unknown, ProjectRouteParams>) => <AccuracyDetails exportEndpoint={exportEndpoint} {...props} />}
          />
          <Route
            exact={true}
            path={`${this.props.match.path}/county/:countyRegionCode`}
            render={(props: RouteComponentProps<{ [x: string]: string }, unknown, ProjectRouteParams>) => <AccuracyDetails exportEndpoint={exportEndpoint} {...props} />}
          />
          <Route
            exact={true}
            path={`${this.props.match.path}/inspection/:inspectionUid`}
            render={(props: RouteComponentProps<{ [x: string]: string }, unknown, ProjectRouteParams>) => <AccuracyDetails exportEndpoint={exportEndpoint} {...props} />}
          />
        </Switch>
      </>
    );
  }

  private renderAccuracyAggregateInspectionDetails = (exportEndpoint: string) => {
    return (
      <>
        {this.props.enabledFeatureFlags.has(Features.ENABLE_VIEW_BY_INSPECTION_UPDATES) ?
          <AccuracyAggregateInspectionDetailsByGroup
            {...this.props}
            networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
            projectId={this.props.project.projectId}
            exportEndpoint={exportEndpoint}
          /> :
          <AccuracyAggregateInspectionDetails
            {...this.props}
            networkAssessmentAnalysisType={this.props.networkAssessmentAnalysisType}
            projectId={this.props.project.projectId}
            exportEndpoint={exportEndpoint}
          />
        }
      </>
    );
  }
}

const WrappedDetails = withFeatureFlagContext(withCountyProjectContext(Details));

export { WrappedDetails as Details, DetailsOnlyProps };
